import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'secondToMinute'
})
export class SecondToMinutePipe implements PipeTransform {

    transform(value: number, ...args) {
        if (value) {
            let hours = Math.floor(value / 3600);
            let minutes = Math.floor(((value - (hours * 3600)) / 60));
            let seconds = (value - (hours * 3600) - (minutes * 60));
            let stringHours = hours > 0?hours + ' ساعت ':'';
            let stringMinutes = minutes > 0?minutes + ' دقیقه ':'';
            let stringSeconds = seconds > 0?seconds + ' ثانیه ':'';
            return stringHours+stringMinutes+stringSeconds;
        }
        return '';
    }


}
